import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
import api from "./api.js";

export default async function changeOrderToReject(orderId, jobId) {
  const Authorization = "bearer " + localStorage.getItem("token");
  const rider_id = localStorage.getItem("rider_id");
  const resp = await fetch(`${API_URL}rest/V1/hubapp/addRemoveOrderInJob`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({
      data: {
        jobId: jobId,
        order_ids: [orderId],
        type: "remove",
      },
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      console.log("changeOrderToInTransitAPI", data);
      return data;
      //   api.callShippingJobs(component, trip_id);
    });

  return resp;
}



// WEBPACK FOOTER //
// ./src/utility/api/changeOrderToReject.js